export default function stringToNumberDirective() {
  console.log('app.components.global.stringToNumberDirective created');
  return {
    require: 'ngModel',
    link: _link,
  };
}

function _link(scope, element, attrs, ngModel) {
  ngModel.$parsers.push(value => value.toString());
  ngModel.$formatters.push(value => parseFloat(value));
}
